<template>
    <div>
        <v-card class="mx-auto relative">
            <v-card-title id="faq-title">
                <h1>{{ title() }}</h1>
            </v-card-title>
            <v-tabs v-model="tab" grow>
                <v-tab>FAQs</v-tab>
                <v-tab>Glossary</v-tab>
                <v-tabs-slider color="#004BB9"></v-tabs-slider>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-expansion-panels>
                        <v-expansion-panel v-for="(faq, faqIndex) in faqs" :key="faqIndex">
                            <v-expansion-panel-header expand-icon="$vuetify.icons.chevronDown" class="chev">
                                {{ faq.title }}</v-expansion-panel-header
                            >
                            <v-expansion-panel-content
                                v-for="(fact, factIndex) in faq.facts"
                                :key="`fact${factIndex}`"
                            >
                                {{ fact }}
                            </v-expansion-panel-content>
                            <v-expansion-panel-content
                                v-for="(subFact, subFactIndex) in faq.subFacts"
                                :key="`exampleT${subFactIndex}`"
                            >
                                <div class="ml-8 font-italic">{{ subFact.title }}</div>
                                <div class="ml-8">{{ subFact.description }}</div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-tab-item>
                <v-tab-item>
                    <v-expansion-panels>
                        <v-expansion-panel v-for="(entry, i) in glossary" :key="i">
                            <v-expansion-panel-header expand-icon="$vuetify.icons.chevronDown" class="chev">
                                {{ entry.term }}</v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                                <p>{{ entry.definition }}</p>
                                <p>{{ entry.definition1 }}</p>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </div>
</template>

<script>
    import { helpService } from "@/service"

    export default {
        data: () => ({
            tab: null,
            fab: false,
            faqs: [],
            glossary: [],
            fav: true,
            menu: false,
            message: false,
            hints: true,
            offset: true,
            drawer: false,
            group: null,
        }),

        watch: {
            group() {
                this.drawer = false
            },
        },

        created() {
            helpService.findFaqs().then(({ faqs }) => (this.faqs = faqs))
            helpService.findGlossaryEntries().then(({ entries }) => (this.glossary = entries))
        },

        methods: {
            close() {
                return this.$emit("close-click", this.$event)
            },

            title() {
                if (this.tab === 0) {
                    return "FAQs"
                }
                if (this.tab === 1) {
                    return "Glossary"
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    #faq-title {
        position: sticky;
        top: 0;
        z-index: 2;
        background: white;
    }

    #faq-info-container {
        height: 100%;
    }

    .v-stepper__header {
        visibility: hidden !important;
    }

    .v-menu__content {
        width: to_rem(770px);
        max-width: to_rem(770px);
        margin: auto;
        overflow-y: scroll;
        max-height: 90vh;
    }

    .v-btn--fab.v-size--default {
        background: #fff !important;
        color: $secondary-color !important;
        min-height: to_rem(56px) !important;
    }

    .v-tab {
        font-style: normal;
        font-weight: 350;
        font-size: to_rem(14px);
        line-height: to_rem(20px);
        text-align: center;
        color: $grey-darken-2 !important;
        border-bottom: to_rem(2px) solid $grey-lighten-1;
        &.v-tab--active {
            font-weight: 600;
            color: $secondary-color;
        }
    }

    .v-expansion-panel {
        &:before {
            box-shadow: 0px 1px 1px rgb(0 0 0 / 10%);
        }

        .v-expansion-panel-header {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(18px);
            line-height: to_rem(28px);

            color: $primary-color;
        }
    }

    .v-card__title {
        display: flex;
        justify-content: space-between;
        padding-left: to_rem(16px);
        padding-top: to_rem(24px);
        padding-right: to_rem(22px);
        h1 {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(22px);
            line-height: to_rem(28px);
            letter-spacing: -0.5px;
            color: $primary-color;
        }
    }
</style>

<style>
    .chev > .v-expansion-panel-header__icon > .v-icon > .v-icon__svg {
        fill: #004bb9;
    }
</style>
